module.exports = __webpack_public_path__ + "googleAuth_70x70.4018f60a0d78d37b390b966de0b07852.png";